var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","lg4":"","offset-lg4":""}},[_c('v-card',[_c('v-card-title',[_vm._v(" Log into MyDocPort ")]),_c('v-card-text',[_vm._v(" Please log in to use MyDocPort ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }